import React from "react"

const Subscribe = () => {
  const [email, setEmail] = React.useState("")
  const [sending, setSending] = React.useState(false)
  const [message, setMessage] = React.useState("")

  async function handleSubmit() {
    setSending(true)
    function validEmail(email: string) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

    if (email.length === 0 || !validEmail(email)) {
      setMessage("Please enter a valid email address.")
    }
    //
    else {
      setMessage("")
      const res = await fetch(`/api/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      })

      const data = await res.json()
      console.log(data)
      if (res.status === 200) {
        setSending(false)
        setEmail("")
        setMessage(`Thanks, you'll be hearing from us soon!`)
      }
      //
      else {
        setSending(false)
        console.log(data)
        setMessage("Something went wrong.")
      }
    }
  }

  return (
    <div className="sm:max-w-xl sm:mx-auto lg:mx-0">
      <div className="sm:flex">
        <div className="min-w-0 flex-1">
          <label htmlFor="email" className="sr-only">
            Email address
          </label>

          <input
            id="email-input"
            name="email"
            type="email"
            placeholder="you@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full px-4 py-3 rounded-md border border-gray-300 text-base text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8CE2A4]"
          />
          <p className="text-left text-alt mt-1 font-medium text-sm">
            {message}
          </p>
          {sending && !message && (
            <p className="text-left text-alt mt-1 font-medium text-sm">
              Sending...
            </p>
          )}
        </div>
        <div className="mt-3 sm:mt-0 sm:ml-3">
          <button
            disabled={sending && !message}
            onClick={handleSubmit}
            className="btn-primary py-[13px] w-full sm:w-32 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none"
            //   className="cursor:pointer block w-full py-3 px-4 rounded-md shadow bg-gradient-to-r
            // from-primary to-primary text-alt font-medium
            // hover:from-primary hover:to-[#27AE60] focus:outline-none
            // focus:ring-2 focus:ring-offset-2 focus:ring-[#8CE2A4]"
          >
            Subscribe
          </button>
        </div>
      </div>
    </div>
  )
}

export default Subscribe
